<template>
  <el-dialog :title="$t('text.editUser')" :visible.sync="dialogShow" @close="closeDialog" @open="openDialog">
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item :label="$t('text.name')" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" autocomplete="off" :placeholder="$t('message.inputName')"/>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="saveUser">{{ $t('text.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  name: "UserEdit",
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  props: {
    show: Boolean,
    formData: Object,
    action: String,
  },
  data() {
    return {
      dialogShow: this.show,
      systemArray: [],
      roleArray: [],
      form: {
        name: "",
        loginName: "",
      },
      formLabelWidth: "120px",
      rules: {
        name: [
          {required: true, message: this.$t('message.inputRealName'), trigger: "blur"},
          {min: 2, max: 10, message: this.$t('message.nameLengthError'), trigger: "blur"},
        ],
        loginName: [
          {required: true, message: this.$t('message.inputLoginName'), trigger: "blur"},
          {min: 6, max: 20, message: this.$t('message.loginNameLengthError'), trigger: "blur"},
        ],
      },
    };
  },
  methods: {
    saveUser() {
      if (this.action === "editUser") {
        let params = {
          id: this.formData.id,
          name: this.form.name,
        };
        this.axios.post("/sysUserInfo/editUser", params).then((res) => {
          if (res.code === 200) {
            this.$notify({
              title: this.$t('text.success'),
              message: res.msg,
              type: "success",
            });

            this.$bus.$emit("refresh"); //通知刷新

            this.closeDialog();
          } else {
            this.$notify.error({
              title: this.$t('text.error'),
              message: res.msg,
            });
          }
        });
      }
      // else {
      //   this.$refs["form"].validate((valid) => {
      //     if (valid) {
      //       this.axios.post("/sysUserInfo/saveUser", this.form).then((res) => {
      //         if (res.code === 200) {
      //           this.$notify({
      //             title: this.$t('text.success'),
      //             message: res.msg,
      //             type: "success",
      //           });
      //
      //           this.$bus.$emit("refresh"); //通知刷新
      //
      //           this.closeDialog();
      //         } else {
      //           this.$notify.error({
      //             title: this.$t('text.error'),
      //             message: res.msg,
      //           });
      //         }
      //       });
      //     } else {
      //       return false;
      //     }
      //   });
      // }
    },
    openDialog() {
      this.systemSelectedChange();
    },
    closeDialog() {
      this.dialogShow = false;
      this.$refs["form"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },

    systemSelectedChange() {
      this.roleArray = [];
      this.axios
          .get("/sysRoleInfo/selectOption", {params: {}})
          .then((res) => {
            if (res.code === 200) {
              this.roleArray = res.data;
            }
            if (this.formData != null) {
              this.form.name = this.formData.name;
              this.form.loginName = this.formData.loginName;
            } else {
              this.form.name = "";
              this.form.loginName = "";
            }
          });
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal;
    },
  },
  created() {
  },
};
</script>

<style scoped>
</style>